import aboutJson from '@/mock/about.json'

export const linkData = (params, cb, error) => {
    cb(aboutJson.linkList)
}

export const quesData = (params, cb, error) => {
    cb(aboutJson.quesList)
}




// WEBPACK FOOTER //
// ./src/api/about.js